import axios from 'axios';
import { getAcceptLanguageHeader } from '../common/utils/languageUtils';

const BASE_URL = import.meta.env.VITE_APP_BASE_URL;

export const baseAxiosInstance = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

baseAxiosInstance.interceptors.request.use((config) => {
  if (config.headers) {
    config.headers['Accept-Language'] = getAcceptLanguageHeader();
  }
  return config;
});

baseAxiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  },
);
